import { useQuery } from '@tanstack/react-query';
import { useServices } from 'index';

export const useGetOrganizationProgressModuleList = (callback?: (selectedModuleId: string) => void) => {
  const learningHubService = useServices().learningHubService;
  return useQuery({
    queryKey: ['organizationProgressModuleList'],
    queryFn: async () => {
      const response = await learningHubService.getModulesWithAssessments();

      if (callback) {
        callback(response.length ? response[0].id : '');
      }

      return response;
    },
    refetchOnWindowFocus: false,
  });
};
